/**
 * Centralized Invoice Status Constants
 *
 * These are the canonical codeId values used by the API
 * (category PAYMENTINVOICESTATUS).
 * NEVER compare against display labels - always use these constants.
 */

export const InvoiceStatus = {
  ISSUED: 'ISSUED',
  PAID: 'PAID',
  CANCELED: 'CANCELED',
} as const

export type InvoiceStatusType = typeof InvoiceStatus[keyof typeof InvoiceStatus]

/**
 * An invoice whose cart is no longer open for editing. Paid and canceled
 * invoices have submitted/closed carts, so re-opening order entry for them
 * would spin up a brand-new empty cart rather than the original order.
 * Comparison is case-insensitive to match the codeId casing used elsewhere.
 */
export function isInvoiceClosed(codeId: string | undefined | null): boolean {
  const normalized = codeId?.toUpperCase()
  return normalized === InvoiceStatus.PAID || normalized === InvoiceStatus.CANCELED
}
